import styled, { css } from 'styled-components'

const ProgressBar = ({ totalSteps = 3, currentStep }) => {
  return (
    <Steps>
      {Array(totalSteps)
        .fill(1)
        .map((_, index) => (
          <Step key={index} isActivate={currentStep >= index + 1} />
        ))}
    </Steps>
  )
}

const Steps = styled.div`
  width: 100%;
  height: 4px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
	margin
`

const Step = ({ isActivate }) => (isActivate ? <ActivateStep /> : <DeactivateStep />)

const stepStyle = css`
  flex-grow: 1;
  border-radius: 42px;

  :not(:last-child) {
    margin-right: 9px;
  }
`

const ActivateStep = styled.div`
  ${stepStyle}
  background-color: #4e4e4e;
`

const DeactivateStep = styled.div`
  ${stepStyle}
  background-color: #ededed;
`

export default ProgressBar
